import experience from './experience.report.store';

export default {
    namespaced: true,
    modules: {
        experience
    }
};
